module.exports = __webpack_public_path__ + "static/media/Oljevaxt@2x.f4d1b1de.png";